/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSpecialCriteriaByIdRequest
 */
export interface UpdateSpecialCriteriaByIdRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSpecialCriteriaByIdRequest
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpecialCriteriaByIdRequest
     */
    facility_id?: string;
}

/**
 * Check if a given object implements the UpdateSpecialCriteriaByIdRequest interface.
 */
export function instanceOfUpdateSpecialCriteriaByIdRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateSpecialCriteriaByIdRequestFromJSON(json: any): UpdateSpecialCriteriaByIdRequest {
    return UpdateSpecialCriteriaByIdRequestFromJSONTyped(json, false);
}

export function UpdateSpecialCriteriaByIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSpecialCriteriaByIdRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
    };
}

export function UpdateSpecialCriteriaByIdRequestToJSON(value?: UpdateSpecialCriteriaByIdRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'facility_id': value.facility_id,
    };
}

